import styled from 'styled-components'
import { customMedia } from 'src/styles/common/common'
import { COLOR } from 'src/service/constant/color'

const NewsException = styled.div`
  display: block;
  margin: 86px auto 124px auto;

  > img {
    margin: 0 auto 32px auto;
    display: flex;
    width: 328px;
    height: 328px;
  }

  > p {
    margin: 0;
    text-align: center;
    font-size: 18px;
    line-height: 26px;
    color: ${COLOR.gray50};
    font-family: NotoSansRegular, sans-serif;
  }

  ${customMedia.lessThan('tablet')`
      margin: 58px auto 150px auto;
      > img{
        width: 200px;
        height : 200px;
        margin: 0 auto 6px auto;
      }
      > p{
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;}
      
`}
`

const NewsWrap = styled.div`
  display: block;
  margin: 0 auto 240px auto;
  ${customMedia.lessThan('tablet')`
    width: 100%;
    max-width:600px;
    margin: 0 auto 124px auto;
`}
`
const NewsItemList = styled.div`
  display: grid;
  grid-template-columns: 356px 356px 356px;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 15px;
  padding-bottom: 9px;
  ${customMedia.lessThan('tablet')`
    grid-template-columns: 49% 49%;
    margin: 0 0 60px 0;
    gap: 13px;
`}
  ${customMedia.lessThan('mobile')`
    gap: 7px;
`}
`
const NewsItem = styled.section`
  display: block;
  //border: 1px solid blue;
  width: 100%;
  height: 282px;
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.08);
  border-radius: 20px;

  > img {
    display: flex;
    border-radius: 20px 20px 0 0;
    width: 100%;
    height: 202px;
  }

  > a {
    white-space: pre-line;
    display: inline-block;
    font-family: NotoSansMedium, sans-serif;
    font-size: 16px;
    line-height: 23px;
    margin: 16px 0 0 17px;
  }

  ${customMedia.lessThan('tablet')`
   height: 100%;
   width: 100%;
   min-height: 170px;
   >img{
    height: 73.5%;
   }
   >a{
    font-size: 13px;
    line-height: 13px;
    margin: 5px 0 0 10px;
    }
`}
  ${customMedia.lessThan('mobile')`
    height: 170px;
    >img{
      width: 100%; 
      height: 122px;
    }
`}
`
export { NewsWrap, NewsItemList, NewsItem, NewsException }
